import LoadingComponent from 'components/loadingComponent/loadingComponent';

import logo from 'assets/images/logo.svg';
import styles from './styles.module.scss';

function MainLoadingComponent() {
	return (
		<div className={styles.loaderContainer}>
			<img src={logo} />
			<LoadingComponent />
		</div>
	);
}

export default MainLoadingComponent;
